import { render, staticRenderFns } from "./ProviderRegistrationRequest.vue?vue&type=template&id=5d67efa1&"
import script from "./ProviderRegistrationRequest.vue?vue&type=script&lang=js&"
export * from "./ProviderRegistrationRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports